import { DamagedParts, SignedUrlMetadata } from "pages/VehicleAnalysis/types";

import { VersionResponse } from "api/getAppVersion";
import { Session } from "types/Session";

import { SessionConfig } from "../../types/SessionConfig";

export const MOCK_SESSION_RESPONSE: Session = {
  id: "fxWNcHMlAQRShss3cRDAmm",
  expiredAt: "2022-06-15T09:22:37.954Z",
  claimId: "claim-id",
  clientId: "string",
  startedAt: null,
  classifiedAt: null,
  completedAt: null,
  mileage: 12000,
  rating: null,
  pointsOfImpact: [],
  damagedParts: [],
  expiryNotifiedAt: null,
  lastReminderSentAt: null,
  vin: null,
  enablePayeeJourney: false,
  damagePhotos: [],
  additionalPhotos: [],
  vehiclePhotos: [],
  vehicleConditions: [],
  sessionConfig: {},
  digitalJourney: {
    firstNamePh: "",
    lastNamePh: "",
    phoneNumberPh: "+393518664899",
    emailPh: "",
    licensePlatePh: "",
    accidentDateTime: null,
    accidentType: null,
    vandalismSeverity: null,
    naturalEventType: null,
    insuranceType: null,
    numInjuredPeople: null,
    driverPresent: null,
    informationOnOtherDriver: null,
    additionalDetails: null,
    numVehiclesInvolved: null,
    informationOnOtherVehicle: null,
    claimHandlingDecision: null,
    cai: null,
    authoritiesIntervention: null,
    accidentResponsibility: null,
    vehicleTypePh: null,
    pointsOfImpactPh: [],
    mileage: null,
    airbagDeployed: null,
    isDrivable: null,
    pointsOfImpactGlass: [],
    vehicleCircumstancePh: null,
    personalCodePh: null,
    otherDriverFirstName: null,
    otherDriverLastName: null,
    otherDriverPersonalCode: null,
    otherVehicleInsurance: null,
    otherVehicleLicensePlate: null,
    otherVehiclePointsOfImpact: [],
    otherVehicleCircumstance: null,
    otherVehicleType: null,
    caiPhotos: [],
    hospitalReportPhotos: [],
    authoritiesPhotos: [],
    injuredPersons: [],
  },
};

export const MOCK_SIGNED_URL =
  "http://car-owner-app-s3-bucket-localstack.localhost.localstack.cloud:4566/images/nish/daaedb9d5623.jpg&x-id=PutObject";
export const MOCK_PATH =
  "http://car-owner-app-s3-bucket-localstack.localhost.localstack.cloud:4566/images/nish/daaedb9d5623.jpg";
export const MOCK_KEY = "images/nish/daaedb9d5623.jpg";
export const MOCK_BUCKET = "car-owner-app-s3-bucket-localstack";

export const MOCK_POST_UPLOAD_RESPONSE: SignedUrlMetadata = {
  url: MOCK_SIGNED_URL,
  path: MOCK_PATH,
  key: MOCK_KEY,
  bucket: MOCK_BUCKET,
  format: "jpeg",
};

export const MOCK_DAMAGED_PARTS_RESPONSE: DamagedParts = {
  damagedParts: ["BBUMPER", "FBUMPER", "BONNET"],
};

export const MOCK_NO_DAMAGED_PARTS_RESPONSE: DamagedParts = { damagedParts: [] };

export const MOCK_VERSION_RESPONSE: VersionResponse = {
  version: "1.0.0",
};

export const MOCK_SESSION_CONFIG: SessionConfig = {
  translationDicts: ["prefix", "other-prefix"],
  contactButton: { url: "tel:1234567890", type: "phone" },
};
